export const getEnvVariables = () => {
  return {
    API_URL: `${process.env.REACT_APP_API_BACK}/api/`,
    BACK_BASE_URL: `${process.env.REACT_APP_API_BACK}/`,
    VUMI_LOGIN_URL: `${process.env.REACT_APP_API_VUMI}/index.php/vip_care/login`,
    DEBUG: process.env.REACT_APP_DEBUG,
    QUOTER_URL: process.env.REACT_APP_API_QUOTER_URL,
  }
}

